module.exports = __webpack_public_path__ + "static/media/button-next.3134986d.png";